import { useMutation } from "@tanstack/react-query";
import { bookAppointment } from "../../../services/doctors";
import { ErrorType } from "../../../types";
import { useToast } from "../../../components/ui/use-toast";

export function useBookAppointment() {
  const { toast } = useToast();
  const { mutate, isPending } = useMutation({
    mutationFn: bookAppointment,
    onError: (error: ErrorType) =>
      toast({
        title: "Failed to book appointment",
        description: error.response.data.description,
        variant: "destructive",
      }),
  });

  return { bookAppointment: mutate, isPending };
}
